import styled from "styled-components"

export const FullFillBox = styled.div< { padding?: string | undefined}>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: ${props => props.padding ? props.padding : 0};
`